import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useMenuServiceButtonStyles = makeStyles((theme) =>
  createStyles({
    button: {
      marginLeft: 'auto'
    },

    menu: {
      width: 155
    },

    activeLink: {
      color: theme.palette.secondary.main
    }
  })
)
